/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Form_Error_ConnectionInputs */

const tr_contact_form_error_connection = /** @type {(inputs: Contact_Form_Error_ConnectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bağlantı hatası. Lütfen tekrar dene.`)
};

const en_contact_form_error_connection = /** @type {(inputs: Contact_Form_Error_ConnectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connection error. Please try again.`)
};

const de_contact_form_error_connection = /** @type {(inputs: Contact_Form_Error_ConnectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbindungsfehler. Bitte erneut versuchen.`)
};

const ru_contact_form_error_connection = /** @type {(inputs: Contact_Form_Error_ConnectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ошибка соединения. Пожалуйста, попробуйте еще раз.`)
};

/**
* | output |
* | --- |
* | "Connection error. Please try again." |
*
* @param {Contact_Form_Error_ConnectionInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const contact_form_error_connection = /** @type {((inputs?: Contact_Form_Error_ConnectionInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Form_Error_ConnectionInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_contact_form_error_connection(inputs)
	if (locale === "de") return de_contact_form_error_connection(inputs)
	if (locale === "ru") return ru_contact_form_error_connection(inputs)
	return tr_contact_form_error_connection(inputs)
});